var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class SonyBraviaIr {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.irConnector = '1';
        // IR codes are from from global cache IR library for a sony bravia with repeat value manaully set to 3
        this.irCodes = {
            inputAv1: ',1,40000,3,1,96,24,24,24,24,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1080',
            inputAv2: ',1,40000,3,1,96,24,48,24,24,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1056',
            inputAv3: ',1,40000,3,1,96,24,24,24,48,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1056',
            inputDmeX: ',1,40000,3,1,96,24,48,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,792',
            inputDvdComponent: ',1,40000,3,1,96,24,24,24,48,24,24,24,24,24,48,24,24,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,48,864',
            inputHd1: ',1,40000,3,1,96,24,24,24,48,24,48,24,24,24,48,24,48,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,48,912',
            inputHd2: ',1,40000,3,1,96,24,48,24,48,24,48,24,24,24,48,24,48,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,48,888',
            inputHdComponent: ',1,40000,3,1,96,24,24,24,48,24,48,24,24,24,48,24,48,24,24,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,48,816',
            inputHdmi1: ',1,40000,3,1,96,24,24,24,48,24,24,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,824',
            inputHdmi1Alternate: ',1,40000,3,1,96,24,24,24,48,24,24,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,1056',
            inputHdmi2: ',1,40000,3,1,96,24,48,24,48,24,24,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,806',
            inputHdmi2Alternate: ',1,40000,3,1,96,24,48,24,48,24,24,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,1032',
            inputHdmi3: ',1,40000,3,1,96,24,24,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,824',
            inputHdmi3Alternate: ',1,40000,3,1,96,24,24,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,1056',
            inputHdmi4: ',1,40000,3,1,96,24,48,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,806',
            inputHdmi4Alternate: ',1,40000,3,1,96,24,48,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,1032',
            inputHdmi5: ',1,40000,3,1,96,24,24,24,48,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,24,24,24,24,24,24,806',
            inputHdmi5Alternate: ',1,40000,3,1,96,24,24,24,48,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,48,24,48,1032',
            inputILink: ',1,40000,3,1,96,24,48,24,24,24,24,24,24,24,24,24,48,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,24,24,48,816',
            inputMemoryStick: ',1,40000,3,1,98,25,49,25,25,25,25,25,25,25,49,25,49,25,25,25,49,25,49,25,49,25,25,25,49,25,25,25,25,25,49,796',
            inputOption1: ',1,40000,3,1,95,23,23,23,47,23,23,23,23,23,23,23,47,23,47,23,47,23,47,23,47,23,23,23,47,23,47,23,47,23,23,772',
            inputOption2: ',1,40000,3,1,95,23,47,23,47,23,23,23,23,23,23,23,47,23,47,23,47,23,47,23,47,23,23,23,47,23,47,23,47,23,23,748',
            inputPcRgb: ',1,40000,3,1,96,25,49,25,49,25,25,25,25,25,25,25,25,25,49,25,49,25,25,25,25,25,25,25,25,1013',
            inputScroll: ',1,40000,3,1,96,24,48,24,24,24,48,24,24,24,24,24,48,24,24,24,48,24,24,24,24,24,24,24,24,1033',
            inputTvVideo: ',1,40000,3,1,96,24,48,24,24,24,48,24,24,24,24,24,48,24,24,24,48,24,24,24,24,24,24,24,24,1032',
            inputVideo1: ',1,40000,3,1,97,24,24,24,24,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1080',
            inputVideo10: ',1,40000,3,1,96,24,48,24,24,24,48,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,810',
            inputVideo11: ',1,40000,3,1,96,24,24,24,48,24,48,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,810',
            inputVideo12: ',1,40000,3,1,96,24,48,24,48,24,48,24,48,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,810',
            inputVideo2: ',1,40000,3,1,97,24,48,24,24,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1058',
            inputVideo3: ',1,40000,3,1,97,24,24,24,48,24,24,24,24,24,24,24,24,24,48,24,48,24,24,24,24,24,24,24,24,1058',
            inputVideo4: ',1,40000,3,1,96,25,48,24,48,24,48,24,24,24,24,25,24,24,48,24,48,24,24,24,24,25,24,24,24,1013',
            inputVideo5: ',1,40000,3,1,96,25,24,24,24,25,24,25,48,24,24,24,24,24,48,24,48,24,24,25,24,24,24,25,24,1058',
            inputVideo6: ',1,40000,3,1,96,25,48,24,24,25,24,24,48,24,24,25,24,25,48,24,48,24,24,24,24,24,24,24,24,1035',
            inputVideo7: ',1,40000,3,1,96,24,24,24,48,24,24,24,24,24,24,24,24,24,48,24,48,24,48,24,48,24,24,24,48,24,24,24,24,24,48,810',
            inputVideo8: ',1,40000,3,1,96,25,49,25,25,25,49,25,25,25,25,25,49,25,49,25,49,25,49,25,49,25,25,25,49,25,49,25,49,25,25,720',
            inputVideo9: ',1,40000,3,1,96,24,24,24,48,24,48,24,24,24,24,24,48,24,48,24,48,24,48,24,48,24,24,24,48,24,48,24,48,24,24,743',
            powerOff: ',1,40000,3,1,96,24,48,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,24,24,24,24,24,990',
            powerOn: ',1,40000,3,1,96,24,24,24,48,24,48,24,48,24,24,24,48,24,24,24,48,24,24,24,24,24,24,24,24,1013',
            volumeDown: ',1,40000,3,1,96,24,48,24,48,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,24,24,24,24,24,1035',
            volumeUp: ',1,40000,3,1,96,24,24,24,48,24,24,24,24,24,48,24,24,24,24,24,48,24,24,24,24,24,24,24,24,1058',
        };
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `ping`,
                next: /ERR(?:\s*|_)\d+/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.buildCommand(`${power ? 'powerOn' : 'powerOff'}`), /completeir,\d:\d|busyIR/i, tags);
                if (!power) {
                    // send confirmation of powering off
                    yield this.socket.send(this.buildCommand('powerOff'), /completeir,\d:\d/i, tags);
                }
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                return power;
            }),
        };
        this.videoInput = {
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.buildCommand(`${code}`), /completeir,\d:\d|busyIR/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return code;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.socket.hasCommands())
                        return;
                    yield this.socket.send('ping', /ERR(?:\s*|_)\d+/i, ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.irConnector = (_b = (_a = config.ir) === null || _a === void 0 ? void 0 : _a.connector) !== null && _b !== void 0 ? _b : '1';
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    buildCommand(name) {
        return `sendir,1:${this.irConnector}${this.irCodes[name]}`;
    }
}
// static properties
SonyBraviaIr.driverType = 'socketDriver';
SonyBraviaIr.key = '-LwF24xYwxN9YDfZ7c9c';
SonyBraviaIr.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
SonyBraviaIr.socketOptions = [
    Object.assign(Object.assign({}, SonyBraviaIr.baseSocketOptions), { port: 4998 }),
];
